import gsap from "gsap";
import ScrollTriggerController from "./scroll-trigger_controller";

export default class StackingCardController extends ScrollTriggerController {

    static values = {
        scale: { type: Number, default: 0.9 },
        scrub: { type: Number, default: 0.2 },
        start: { type: String, default: 'top top' },
        end:   { type: String, default: 'bottom top' },
        ease:  { type: String, default: 'none' },
    };

    static targets = [
        'card',
    ];

    timeline;

    connect() {
        const elementToAnimate = this.hasCardTarget ? this.cardTarget : this.element;

        this.timeline = gsap.timeline({
            scrollTrigger: {
                trigger: this.element,
                start:   this.startValue,
                end:     this.endValue,
                scrub:   this.scrubValue,
                // markers: true,
            },
        });

        this.timeline.to(elementToAnimate, {
            scale: this.scaleValue,
            ease:  this.easeValue,
        });
    }

    disconnect() {
        this.timeline?.kill();
        this.timeline = null;
    }
}
